import React, {Component} from 'react'

import Registry from '../../../registry/index';

export default class PmMessageNotification extends Component {
    render() {
        const lang = Registry.get('locale');

        const { currentUser, message } = this.props;
        const type = message.payload.data.type;
        let pending = false;

        let messageText = "";

        switch(type) {
            case 'private_token':
                if (message.sender_uid == currentUser.uid) {
                    messageText = lang.tip_private_sent(message.recipient_nick, message.payload.data.amount);
                } else {
                    messageText = lang.tip_private(message.sender_nick, message.payload.data.amount);
                }
                pending = true;
                break;

            case 'history_deleted':
                messageText = lang.pm_history_deleted(message.sender_nick);
                break;

            case 'history':
                messageText = lang.new_messages;
                break;

            case 'user_connected':
                messageText = lang.pm_user_connected(user);
                break;
            case 'user_disconnected':
                messageText = lang.pm_user_disconnected(user);
                break;
            
            case 'tip_private_sent':
                
                break;
            default:
                break;
        }

        return (
            <div className={pending ? "message service pending" : "message service"}><p>{messageText}</p></div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmMessageNotification/index.js